import api from "./api";

export const MudarSenhaEntregador = async (user, senha) => {
  try {
    await api.put(`/usuarios/${user._id}/`, { senha: senha });
  } catch (error) {
    throw error;
  }
};

export const ListarEntregadores = async (page = 1) => {
  try {
    const entregadores = await api.get(`/entregadores?page=${page}`);
    return entregadores.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarEntregador = async (dados, dadosEndereco, dadosUsuario) => {
  try {
    const endereco = await api.post(`/enderecos`, dadosEndereco);
    const usuario = await api.post(`/registrar`, dadosUsuario);

    if (endereco.data && usuario.data.usuario) {
      dados = {
        ...dados,
        endereco: endereco.data._id,
        usuario: usuario.data.usuario._id,
      };
      const entregadores = await api.post(`/entregadores`, dados);
      return entregadores.data;
    }
  } catch (error) {
    throw error;
  }
};

export const EditarEntregador = async (
  dados,
  dadosEndereco,
  dadosUsuario,
  entregador,
) => {
  try {
    await api.put(`/enderecos/${entregador.endereco._id}`, dadosEndereco);
    await api.put(`/usuarios/${entregador.usuario._id}`, dadosUsuario);
    const res = await api.put(`/entregadores/${entregador._id}`, dados);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarEntregador = async (dados) => {
  try {
    const entregadores = await api.delete(`/entregadores/${dados._id}`);
    return entregadores.data;
  } catch (error) {
    throw error;
  }
};
